export type TImageBackupDestination = 'GOOGLE_DRIVE' | 'NONE' | ''

export const IMAGE_BACKUP_DESTINATION = {
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',
  NONE: 'NONE'
} as const

// Module-level holder so non-redux code (upload services) can read the
// preference synchronously. Kept in sync with Settings.gdrive.imageBackupDestination.
let currentDestination: TImageBackupDestination = ''

export const setImageBackupDestination = (destination?: string | null): void => {
  currentDestination =
    destination === IMAGE_BACKUP_DESTINATION.GOOGLE_DRIVE ||
    destination === IMAGE_BACKUP_DESTINATION.NONE
      ? destination
      : ''
}

export const getImageBackupDestination = (): TImageBackupDestination => currentDestination
